import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React from 'react';
import RowSkeleton from './partials/RowSkeleton';
import RowWithImageSkeleton from './partials/RowWithImageSkeleton';
const DesktopTableSkeleton = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <th className="h-14 w-1/4 rounded-l-lg bg-gray-200 px-6"><RowSkeleton size="lg" seed={1} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></th>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th className="h-14 w-1/4 bg-gray-200 px-6"><RowSkeleton seed={2} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></th>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <th className="h-14 w-1/4 bg-gray-200 px-6"><RowSkeleton seed={3} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></th>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <thead className="mb-4"><tr className="mb-4">{t0}{t1}{t2}<th className="h-14 w-1/4 rounded-r-lg bg-gray-200 px-6"><RowSkeleton className="justify-end" seed={4} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></th></tr></thead>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <td className="w-1/4 rounded-tl-lg bg-gray-200 px-6 py-3.5"><RowWithImageSkeleton seed={5} data-sentry-element="RowWithImageSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={6} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={7} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <tr className="border-b border-b-gray-100 px-4 last:border-none">{t4}{t5}{t6}<td className="w-1/4 rounded-tr-lg bg-gray-200 px-6"><RowSkeleton className="justify-end" seed={8} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td></tr>;
    t8 = [...Array(4)].map(_temp);
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <td className="w-1/4 rounded-bl-lg bg-gray-200 px-6 py-3.5"><RowWithImageSkeleton seed={200} data-sentry-element="RowWithImageSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={201} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={202} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <table className="mt-8 hidden w-full animate-pulse lg:table" data-sentry-component="DesktopTableSkeleton" data-sentry-source-file="index.tsx">{t3}<tbody className="before:block before:h-4">{t7}{t8}<tr className="border-b border-b-gray-100 px-4 last:border-none">{t9}{t10}{t11}<td className="w-1/4 rounded-br-lg bg-gray-200 px-6"><RowSkeleton className="justify-end" seed={203} data-sentry-element="RowSkeleton" data-sentry-source-file="index.tsx" /></td></tr></tbody></table>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
};
export default DesktopTableSkeleton;
function _temp(_, i) {
  return <tr key={i} className="border-b border-b-gray-100 px-4 last:border-none"><td className="w-1/4 bg-gray-200 px-6 py-3.5"><RowWithImageSkeleton seed={100 + i * 10} /></td><td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={101 + i * 10} /></td><td className="w-1/4 bg-gray-200 px-6"><RowSkeleton seed={102 + i * 10} /></td><td className="w-1/4 bg-gray-200 px-6"><RowSkeleton className="justify-end" seed={103 + i * 10} /></td></tr>;
}